import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const PlusIcon: React.FC = FaIcons.FaPlusCircle as unknown as React.FC;
const MinusIcon: React.FC = FaIcons.FaMinusCircle as unknown as React.FC;

const FAQAccordion: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleItem = (index: number) => {
        setOpenIndex(prev => (prev === index ? null : index));
    };

    const faqs = [
        {
            question: 'How accurate is the transcription?',
            answer: 'Our AI delivers 95%+ accuracy for clear audio.',
        },
        {
            question: 'Can I integrate this with my CRM?',
            answer: 'Yes, we offer integration options for most popular CRMs.',
        },
        {
            question: 'Is my data private?',
            answer:
                'Absolutely. We use end-to-end encryption and follow GDPR & CCPA compliance standards.',
        },
    ];

    return (
        <div className="container py-5">
            <h2 className="text-center mb-4">Got Questions? We’ve Got Answers!</h2>
            <div className="accordion-custom">
                {faqs.map((faq, index) => (
                    <div key={index} className="border-bottom py-3">
                        <div
                            className="d-flex align-items-start gap-3"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleItem(index)}
                        >
                            <div className="mt-1 text-danger">
                                {openIndex === index ? <MinusIcon /> : <PlusIcon />}
                            </div>
                            <div className="flex-grow-1">
                                <strong>{faq.question}</strong>
                                <Collapse in={openIndex === index}>
                                    <div className="mt-2 text-muted">{faq.answer}</div>
                                </Collapse>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQAccordion;
